// Mock data for initial frontend development
// Will be replaced with real API data later

export const mockMarketData = [
  { id: 1, symbol: 'BTC/USDT', name: 'Bitcoin', price: 110513.00, change: 0.46, icon: '₿', type: 'crypto' },
  { id: 2, symbol: 'ETH/USDT', name: 'Ethereum', price: 3892.94, change: 0.88, icon: 'Ξ', type: 'crypto' },
  { id: 3, symbol: 'USDT/USDT', name: 'Tether', price: 1.00, change: 0.02, icon: '₮', type: 'crypto' },
  { id: 4, symbol: 'SOL/USDT', name: 'Solana', price: 187.10, change: 0.79, icon: '◎', type: 'crypto' },
  { id: 5, symbol: 'XRP/USDT', name: 'Ripple', price: 2.52, change: 0.68, icon: 'X', type: 'crypto' },
  { id: 6, symbol: 'DOGE/USDT', name: 'Dogecoin', price: 0.19, change: 0.75, icon: 'Ð', type: 'crypto' },
  { id: 7, symbol: 'USDC/USDT', name: 'USD Coin', price: 1.00, change: -0.01, icon: '$', type: 'crypto' },
  { id: 8, symbol: 'TON/USDT', name: 'Toncoin', price: 2.33, change: 0.39, icon: '💎', type: 'crypto' },
  { id: 9, symbol: 'BNB/USDT', name: 'Binance Coin', price: 1090.96, change: 0.41, icon: 'B', type: 'crypto' },
  { id: 10, symbol: 'ADA/USDT', name: 'Cardano', price: 0.92, change: 1.23, icon: '₳', type: 'crypto' },
  { id: 11, symbol: 'GOLD/USDT', name: 'Gold', price: 2685.45, change: 0.25, icon: '🏅', type: 'gold' },
  { id: 12, symbol: 'GOLD/BTC', name: 'Gold/Bitcoin', price: 0.0243, change: -0.21, icon: '🏅', type: 'gold' },
  { id: 13, symbol: 'GOLD/ETH', name: 'Gold/Ethereum', price: 0.6897, change: -0.63, icon: '🏅', type: 'gold' },
];

export const mockUserBalance = {
  usdt: 10000.00,
  btc: 0.5,
  eth: 2.5,
  gold: 5.0
};

export const mockTransactions = [
  { id: 1, type: 'buy', pair: 'BTC/USDT', amount: 0.1, price: 110000, total: 11000, date: '2025-01-02 14:30:00', status: 'completed' },
  { id: 2, type: 'sell', pair: 'ETH/USDT', amount: 1.0, price: 3850, total: 3850, date: '2025-01-02 12:15:00', status: 'completed' },
  { id: 3, type: 'buy', pair: 'GOLD/USDT', amount: 2.0, price: 2680, total: 5360, date: '2025-01-01 18:45:00', status: 'completed' },
];

export const mockFuturesPositions = [
  { id: 1, symbol: 'BTC/USDT', side: 'long', leverage: '10x', entryPrice: 108500, currentPrice: 110513, amount: 1.0, pnl: 2013, pnlPercent: 18.56 },
  { id: 2, symbol: 'ETH/USDT', side: 'short', leverage: '5x', entryPrice: 3950, currentPrice: 3892.94, amount: 5.0, pnl: 285.30, pnlPercent: 7.21 },
];

export const mockOrderBook = {
  bids: [
    { price: 110510, amount: 0.5234, total: 57840.45 },
    { price: 110505, amount: 1.2341, total: 136374.87 },
    { price: 110500, amount: 2.4567, total: 271465.35 },
  ],
  asks: [
    { price: 110515, amount: 0.8765, total: 96876.39 },
    { price: 110520, amount: 1.5432, total: 170554.46 },
    { price: 110525, amount: 0.9876, total: 109162.29 },
  ]
};